import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Question = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C10.486 2 6 6.486 6 12C6 13.103 6.897 14 8 14H12C13.103 14 14 13.103 14 12C14 10.897 14.897 10 16 10C17.103 10 18 10.897 18 12C18 13.717 16.896 14.472 14.946 15.658C12.742 16.998 10 18.666 10 23V27C10 28.654 11.346 30 13 30H15C16.654 30 18 28.654 18 27V23C18 21.966 18.852 21.422 20.484 20.472C22.812 19.117 26 17.261 26 12C26 6.486 21.514 2 16 2V2ZM16 27C16 27.551 15.551 28 15 28H13C12.449 28 12 27.551 12 27V24H16V27ZM19.478 18.744C18.047 19.577 16.575 20.434 16.133 22H12.07C12.433 19.527 14.165 18.474 15.986 17.367C17.868 16.223 20.001 14.926 20.001 12C20.001 9.794 18.207 8 16.001 8C13.795 8 12.001 9.794 12.001 12H8.001C8.001 7.589 11.59 4 16.001 4C20.412 4 24.001 7.589 24.001 12C24.001 16.111 21.702 17.45 19.479 18.744H19.478Z" />
	</svg>
);

export default Question;
